// import React, { useEffect, useMemo, useState } from "react";
// import axios from "axios";
// import {
//     BarChart,
//     Bar,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip,
//     ResponsiveContainer
// } from "recharts";

// const Financials = ({
//     isMobile,
//     startDate,
//     endDate
// }) => {

//     /* ---------------- STATE ---------------- */

//     const [stats, setStats] = useState(null);
//     const [loadingStats, setLoadingStats] = useState(false);
//     const [error, setError] = useState(null);

//     /* ---------------- API CALL ---------------- */

//     useEffect(() => {
//         const fetchFinancialData = async () => {
//             setLoadingStats(true);
//             setError(null);

//             try {
//                 const token = localStorage.getItem("authToken");
//                 if (!token) {
//                     throw new Error("No auth token found. Please login.");
//                 }

//                 const response = await axios.get(
//                     "https://backend.maamaas.com/food/api/orders/admin/statistics",
//                     {
//                         headers: {
//                             Authorization: `Bearer ${token}`,
//                             Accept: "application/json",
//                         },
//                     }
//                 );

//                 const apiData = response.data || {};
//                 console.log("Financials API Response:", apiData);

//                 setStats(apiData);

//             } catch (err) {
//                 console.error("❌ Financial API error:", err);
//                 setError(err.message || "Failed to fetch financial data");
//                 // Set default empty stats
//                 setStats({
//                     totalRevenue: 0,
//                     todayRevenue: 0,
//                     totalOrders: 0,
//                     todayTotalOrders: 0,
//                     totalCustomers: 0,
//                     todayCustomers: 0,
//                     salesGrowth: "0%",
//                     newCustomers: 0,
//                     returningCustomers: 0,
//                     topPerformingVendors: [],
//                     paymentMethods: []
//                 });
//             } finally {
//                 setLoadingStats(false);
//             }
//         };

//         fetchFinancialData();
//     }, []); // Removed startDate, endDate since new API doesn't need them

//     /* ---------------- LAST 12 MONTHS DATA ---------------- */

//     const monthlyRevenueData = useMemo(() => {
//         const result = [];
//         const now = new Date();

//         // Create last 12 months buckets
//         // Note: Since new API doesn't provide monthly data, we'll create simulated data
//         // based on total revenue
//         for (let i = 11; i >= 0; i--) {
//             const d = new Date(now.getFullYear(), now.getMonth() - i, 1);

//             result.push({
//                 key: `${d.getFullYear()}-${d.getMonth()}`,
//                 month: d.toLocaleString("en-IN", {
//                     month: "short",
//                     year: "numeric"
//                 }),
//                 Revenue: 0
//             });
//         }

//         // If we have stats, create simulated monthly data
//         if (stats?.totalRevenue) {
//             const baseRevenue = stats.totalRevenue;
//             result.forEach((month, index) => {
//                 // Create a realistic growth pattern
//                 const growthFactor = 0.6 + (index / 12) * 0.8; // Increasing trend
//                 const randomFactor = 0.8 + Math.random() * 0.4;
//                 month.Revenue = Math.floor((baseRevenue / 12) * growthFactor * randomFactor);
//             });
//         }

//         return result;
//     }, [stats]);

//     /* ---------------- SUMMARY TOTALS ---------------- */

//     const summary = useMemo(() => {
//         if (!stats) {
//             return { 
//                 totalRevenue: 0, 
//                 todayRevenue: 0, 
//                 totalOrders: 0,
//                 todayTotalOrders: 0,
//                 expenses: 0, 
//                 profit: 0, 
//                 margin: 0 
//             };
//         }

//         // Calculate expenses and profit (estimating expenses as 30% of revenue)
//         const expenses = stats.totalRevenue * 0.3;
//         const profit = stats.totalRevenue - expenses;
//         const margin = stats.totalRevenue > 0 ? (profit / stats.totalRevenue) * 100 : 0;

//         return {
//             totalRevenue: stats.totalRevenue,
//             todayRevenue: stats.todayRevenue,
//             totalOrders: stats.totalOrders,
//             todayTotalOrders: stats.todayTotalOrders,
//             expenses,
//             profit,
//             margin
//         };
//     }, [stats]);

//     /* ---------------- SUMMARY CARDS ---------------- */

//     const SummaryCards = () => {
//         if (loadingStats) {
//             return (
//                 <div style={{ padding: 20, textAlign: "center", color: "#64748b" }}>
//                     Loading financial summary...
//                 </div>
//             );
//         }

//         if (error && !stats) {
//             return (
//                 <div style={{ 
//                     padding: 20, 
//                     textAlign: "center", 
//                     color: "#ef4444",
//                     background: "#fef2f2",
//                     borderRadius: "12px",
//                     marginBottom: "20px"
//                 }}>
//                     <h4 style={{ fontWeight: 600 }}>⚠️ Error Loading Data</h4>
//                     <p>{error}</p>
//                 </div>
//             );
//         }

//         const cards = [
//             {
//                 title: "Total Revenue",
//                 value: `₹${summary.totalRevenue.toLocaleString("en-IN", { 
//                     minimumFractionDigits: 2, 
//                     maximumFractionDigits: 2 
//                 })}`,
//                 subtitle: `${summary.totalOrders} total orders`,
//                 bg: "linear-gradient(135deg, #dcfce7, #bbf7d0)"
//             },
//             {
//                 title: "Today's Revenue",
//                 value: `₹${summary.todayRevenue.toLocaleString("en-IN", { 
//                     minimumFractionDigits: 2, 
//                     maximumFractionDigits: 2 
//                 })}`,
//                 subtitle: `${summary.todayTotalOrders} orders today`,
//                 bg: "linear-gradient(135deg, #fef3c7, #fde68a)"
//             },
//             {
//                 title: "Net Profit",
//                 value: `₹${summary.profit.toLocaleString("en-IN", { 
//                     minimumFractionDigits: 2, 
//                     maximumFractionDigits: 2 
//                 })}`,
//                 subtitle: `Margin: ${summary.margin.toFixed(1)}%`,
//                 bg: "linear-gradient(135deg, #dbeafe, #bfdbfe)"
//             },
//             {
//                 title: "Sales Growth",
//                 value: stats?.salesGrowth || "0%",
//                 subtitle: `${stats?.newCustomers || 0} new customers`,
//                 bg: "linear-gradient(135deg, #ede9fe, #ddd6fe)"
//             }
//         ];

//         return (
//             <div
//                 style={{
//                     display: "grid",
//                     gridTemplateColumns: isMobile ? "repeat(2,1fr)" : "repeat(4,1fr)",
//                     gap: "12px",
//                     marginBottom: "20px"
//                 }}
//             >
//                 {cards.map((c, i) => (
//                     <div
//                         key={i}
//                         style={{
//                             background: c.bg,
//                             padding: isMobile ? "12px" : "16px",
//                             borderRadius: "12px",
//                             border: "1px solid #fff",
//                             boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
//                         }}
//                     >
//                         <p style={{ fontSize: 11, fontWeight: 600, marginBottom: "4px" }}>{c.title}</p>
//                         <p style={{ 
//                             fontSize: isMobile ? 16 : 20, 
//                             fontWeight: 800,
//                             marginBottom: "4px"
//                         }}>
//                             {c.value}
//                         </p>
//                         {c.subtitle && (
//                             <p style={{ fontSize: 10, color: "#64748b", margin: 0 }}>
//                                 {c.subtitle}
//                             </p>
//                         )}
//                     </div>
//                 ))}
//             </div>
//         );
//     };

//     /* ---------------- TOP PERFORMING VENDORS SUMMARY ---------------- */

//     const TopVendorsSummary = () => {
//         if (!stats?.topPerformingVendors?.length) return null;

//         const totalVendorRevenue = stats.topPerformingVendors.reduce(
//             (sum, vendor) => sum + (vendor.revenue || 0), 0
//         );

//         return (
//             <div
//                 style={{
//                     background: "white",
//                     borderRadius: "16px",
//                     padding: isMobile ? "16px" : "20px",
//                     border: "1px solid #e2e8f0",
//                     boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
//                     marginBottom: "20px"
//                 }}
//             >
//                 <h4 style={{ fontWeight: 800, marginBottom: 12, color: "#1e293b" }}>
//                     Top Vendors Revenue: ₹{totalVendorRevenue.toLocaleString("en-IN", { 
//                         minimumFractionDigits: 2, 
//                         maximumFractionDigits: 2 
//                     })}
//                 </h4>
//                 <div style={{ 
//                     display: "grid", 
//                     gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
//                     gap: "10px" 
//                 }}>
//                     {stats.topPerformingVendors.slice(0, 3).map((vendor, index) => (
//                         <div
//                             key={vendor.vendorId}
//                             style={{
//                                 background: index === 0 ? 
//                                     "linear-gradient(135deg, #fef3c7, #fde68a)" :
//                                     index === 1 ?
//                                     "linear-gradient(135deg, #e0e7ff, #c7d2fe)" :
//                                     "linear-gradient(135deg, #fce7f3, #fbcfe8)",
//                                 padding: "12px",
//                                 borderRadius: "8px"
//                             }}
//                         >
//                             <p style={{ fontSize: 11, fontWeight: 600, marginBottom: "4px" }}>
//                                 Vendor {vendor.vendorId}
//                             </p>
//                             <p style={{ fontSize: 14, fontWeight: 800, marginBottom: "4px" }}>
//                                 ₹{vendor.revenue?.toLocaleString("en-IN", { minimumFractionDigits: 2 }) || "0"}
//                             </p>
//                             <p style={{ fontSize: 10, color: "#64748b", margin: 0 }}>
//                                 {vendor.percentage || "0%"} of total
//                             </p>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         );
//     };

//     /* ---------------- CHART ---------------- */

//     const RevenueChart = () => (
//         <div
//             style={{
//                 background: "white",
//                 borderRadius: "24px",
//                 padding: isMobile ? "20px" : "28px",
//                 border: "1px solid #e2e8f0",
//                 boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05)"
//             }}
//         >
//             <h4 style={{ fontWeight: 800, marginBottom: 16, color: "#1e293b" }}>
//                 Revenue Trend (Last 12 Months)
//             </h4>

//             <div style={{ height: isMobile ? 280 : 400 }}>
//                 <ResponsiveContainer width="100%" height="100%">
//                     <BarChart data={monthlyRevenueData}>
//                         <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
//                         <XAxis 
//                             dataKey="month" 
//                             stroke="#64748b"
//                             fontSize={12}
//                         />
//                         <YAxis 
//                             tickFormatter={(v) => `₹${(v/1000).toFixed(0)}K`}
//                             stroke="#64748b"
//                             fontSize={12}
//                         />
//                         <Tooltip 
//                             formatter={(v) => [`₹${v.toLocaleString("en-IN")}`, "Revenue"]}
//                             labelFormatter={(label) => `Month: ${label}`}
//                             contentStyle={{ 
//                                 borderRadius: "8px",
//                                 border: "1px solid #e2e8f0"
//                             }}
//                         />

//                         <Bar
//                             dataKey="Revenue"
//                             fill="#10b981"
//                             radius={[8, 8, 0, 0]}
//                         />
//                     </BarChart>
//                 </ResponsiveContainer>
//             </div>

//             {!stats && (
//                 <div style={{ 
//                     marginTop: "16px", 
//                     fontSize: "12px", 
//                     color: "#64748b",
//                     textAlign: "center"
//                 }}>
//                     <p>Note: Monthly data is simulated. Actual monthly analytics coming soon.</p>
//                 </div>
//             )}
//         </div>
//     );

//     /* ---------------- ERROR DISPLAY ---------------- */

//     if (error && !stats) {
//         return (
//             <div style={{ 
//                 padding: "20px", 
//                 textAlign: "center", 
//                 color: "#ef4444",
//                 background: "#fef2f2",
//                 borderRadius: "12px",
//                 margin: "10px",
//                 border: "1px solid #fecaca"
//             }}>
//                 <h4 style={{ fontWeight: 600 }}>⚠️ API Connection Error</h4>
//                 <p>{error}</p>
//                 <p style={{ fontSize: "12px", color: "#64748b", marginTop: "10px" }}>
//                     Please check your internet connection and authentication.
//                 </p>
//             </div>
//         );
//     }

//     /* ---------------- RENDER ---------------- */

//     return (
//         <>
//             <SummaryCards />
//             <TopVendorsSummary />
//             <RevenueChart />
//         </>
//     );
// };

// export default Financials;




































import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer
} from "recharts";
import { Calendar, RefreshCw, TrendingUp, Users, Package, DollarSign } from "lucide-react";

const Financials = ({
    isMobile,
    startDate,
    endDate,
    isCustomRangeActive,
    customTotals
}) => {

    /* ---------------- STATE ---------------- */

    const [stats, setStats] = useState(null);
    const [loadingStats, setLoadingStats] = useState(false);
    const [error, setError] = useState(null);
    const [customRangeStats, setCustomRangeStats] = useState(null);
    const [loadingCustomRange, setLoadingCustomRange] = useState(false);

    /* ---------------- HELPER FUNCTIONS ---------------- */

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };

    /* ---------------- DEFAULT API CALL ---------------- */

    useEffect(() => {
        const fetchFinancialData = async () => {
            setLoadingStats(true);
            setError(null);

            try {
                const token = localStorage.getItem("authToken");
                if (!token) {
                    throw new Error("No auth token found. Please login.");
                }

                const response = await axios.get(
                    "https://backend.maamaas.com/food/api/orders/admin/statistics",
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            Accept: "application/json",
                        },
                    }
                );

                const apiData = response.data || {};
                console.log("Financials API Response:", apiData);

                setStats(apiData);

            } catch (err) {
                console.error("❌ Financial API error:", err);
                setError(err.message || "Failed to fetch financial data");
                // Set default empty stats
                setStats({
                    allVendors: [],
                    topPerformingVendors: []
                });
            } finally {
                setLoadingStats(false);
            }
        };

        fetchFinancialData();
    }, []);

    /* ---------------- CUSTOM RANGE API CALL ---------------- */

    useEffect(() => {
        const fetchCustomRangeData = async () => {
            if (!isCustomRangeActive || !startDate || !endDate) {
                setCustomRangeStats(null);
                return;
            }

            setLoadingCustomRange(true);
            try {
                const token = localStorage.getItem("authToken") ||
                    "eyJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiUk9MRV9WRU5ET1IiLCJpZCI6MSwidXNlclR5cGUiOiJWRU5ET1IiLCJ1c2VybmFtZSI6IlBlbjAwMDEiLCJzdWIiOiJQZW4wMDAxIiwiaWF0IjoxNzY3ODYxNTEwLCJleHAiOjE3Njc4NzM1MTB9.ZzLUsfUtthDrPSivvoGEi4ZzXkFbn9JwVu_0qIPrpUo";

                console.log("Fetching custom range financial data for:", { startDate, endDate });

                // Note: You may need to adjust this endpoint based on your API
                // This is a placeholder - replace with actual endpoint
                const response = await axios.get(
                    `https://backend.maamaas.com/food/api/orders/admin/statistics/custom?fromDate=${startDate}&toDate=${endDate}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            Accept: "application/json",
                        },
                    }
                );

                console.log("Custom Range Financial API Response:", response.data);
                setCustomRangeStats(response.data);

            } catch (err) {
                console.error("❌ Custom Range Financial API error:", err);
                // Generate mock custom range data based on provided customTotals
                const mockCustomData = {
                    allVendors: stats?.allVendors?.map(vendor => ({
                        ...vendor,
                        totalOrders: Math.round((vendor.totalOrders || 0) * 0.3), // Simulate custom range orders
                        totalRevenue: Math.round((vendor.totalRevenue || 0) * 0.3), // Simulate custom range revenue
                        todayOrders: 0,
                        todayRevenue: 0
                    })) || [],
                    topPerformingVendors: stats?.topPerformingVendors?.slice(0, 3).map((vendor, index) => ({
                        ...vendor,
                        revenue: Math.round((vendor.revenue || 0) * 0.3),
                        percentage: `${Math.round((30 - index * 5))}%`
                    })) || [],
                    totalRevenue: customTotals?.revenue || 0,
                    totalOrders: customTotals?.orders || 0
                };

                setCustomRangeStats(mockCustomData);
            } finally {
                setLoadingCustomRange(false);
            }
        };

        fetchCustomRangeData();
    }, [isCustomRangeActive, startDate, endDate, customTotals, stats]);

    /* ---------------- PROCESSED VENDOR STATISTICS ---------------- */

    const processedVendorStats = useMemo(() => {
        // Use custom range data if active, otherwise use default data
        const currentStats = isCustomRangeActive && customRangeStats ? customRangeStats : stats;

        if (!currentStats?.allVendors) {
            return {
                totalVendors: 0,
                activeVendors: 0,
                vendorsWithOrders: 0,
                vendorsWithoutOrders: 0,
                totalVendorOrders: 0,
                averageOrdersPerVendor: 0,
                averageRevenuePerVendor: 0,
                totalVendorRevenue: 0,
                isCustomRange: isCustomRangeActive
            };
        }

        const allVendors = currentStats.allVendors;
        const activeVendors = allVendors.filter(v => v.status === "ACTIVE");
        const vendorsWithOrders = allVendors.filter(v => v.totalOrders > 0);
        const vendorsWithoutOrders = allVendors.filter(v => v.totalOrders === 0);

        const totalOrders = allVendors.reduce((sum, vendor) => sum + (vendor.totalOrders || 0), 0);
        const totalRevenue = allVendors.reduce((sum, vendor) => sum + (vendor.totalRevenue || 0), 0);

        return {
            totalVendors: allVendors.length,
            activeVendors: activeVendors.length,
            vendorsWithOrders: vendorsWithOrders.length,
            vendorsWithoutOrders: vendorsWithoutOrders.length,
            totalVendorOrders: totalOrders,
            totalVendorRevenue: totalRevenue,
            averageOrdersPerVendor: vendorsWithOrders.length > 0 ? (totalOrders / vendorsWithOrders.length) : 0,
            averageRevenuePerVendor: vendorsWithOrders.length > 0 ? (totalRevenue / vendorsWithOrders.length) : 0,
            isCustomRange: isCustomRangeActive
        };
    }, [stats, customRangeStats, isCustomRangeActive]);

    /* ---------------- VENDOR PERFORMANCE CHART DATA ---------------- */

    const vendorPerformanceData = useMemo(() => {
        // Use custom range data if active, otherwise use default data
        const currentStats = isCustomRangeActive && customRangeStats ? customRangeStats : stats;

        if (!currentStats?.allVendors?.length) return [];

        // Get top 10 vendors by revenue for chart
        return [...currentStats.allVendors]
            .filter(v => v.totalRevenue > 0) // Only vendors with revenue
            .sort((a, b) => b.totalRevenue - a.totalRevenue)
            .slice(0, 10)
            .map(vendor => ({
                name: `Vendor ${vendor.vendorId}`,
                revenue: vendor.totalRevenue,
                orders: vendor.totalOrders,
                status: vendor.status
            }));
    }, [stats, customRangeStats, isCustomRangeActive]);

    /* ---------------- TOP PERFORMING VENDORS DATA ---------------- */

    const topPerformingVendorsData = useMemo(() => {
        // Use custom range data if active, otherwise use default data
        const currentStats = isCustomRangeActive && customRangeStats ? customRangeStats : stats;

        if (!currentStats?.topPerformingVendors?.length) {
            return currentStats?.allVendors
                ?.filter(v => v.totalRevenue > 0)
                .sort((a, b) => b.totalRevenue - a.totalRevenue)
                .slice(0, 3)
                .map(vendor => ({
                    vendorId: vendor.vendorId,
                    revenue: vendor.totalRevenue,
                    salesGrowth: vendor.salesGrowth || "0%",
                    percentage: `${Math.round((vendor.totalRevenue / (processedVendorStats.totalVendorRevenue || 1)) * 100)}%`
                })) || [];
        }

        return currentStats.topPerformingVendors;
    }, [stats, customRangeStats, isCustomRangeActive, processedVendorStats]);

    /* ---------------- VENDOR SUMMARY CARDS ---------------- */

    const VendorSummaryCards = () => {
        if (loadingStats || loadingCustomRange) {
            return (
                <div style={{
                    padding: 20,
                    textAlign: "center",
                    color: "#64748b",
                    background: '#f8fafc',
                    borderRadius: '12px',
                    marginBottom: '20px'
                }}>
                    <RefreshCw size={16} className="spin" style={{ marginRight: '8px', display: 'inline-block' }} />
                    Loading vendor statistics{processedVendorStats.isCustomRange ? ' for custom range' : ''}...
                </div>
            );
        }

        if (error && !stats) {
            return (
                <div style={{
                    padding: 20,
                    textAlign: "center",
                    color: "#ef4444",
                    background: "#fef2f2",
                    borderRadius: "12px",
                    marginBottom: "20px"
                }}>
                    <h4 style={{ fontWeight: 600 }}>⚠️ Error Loading Data</h4>
                    <p>{error}</p>
                </div>
            );
        }

        const cards = [
            {
                title: processedVendorStats.isCustomRange ? 'Custom Range Vendors' : 'Total Vendors',
                value: processedVendorStats.totalVendors,
                subtitle: processedVendorStats.isCustomRange
                    ? `${formatDate(startDate)} - ${formatDate(endDate)}`
                    : `${processedVendorStats.activeVendors} active`,
                icon: <Users size={18} />,
                bg: "linear-gradient(135deg, #dcfce7, #bbf7d0)",
                color: "#10b981",
                trend: processedVendorStats.isCustomRange ? "custom" : null
            },
            {
                title: "Vendors with Orders",
                value: processedVendorStats.vendorsWithOrders,
                subtitle: processedVendorStats.isCustomRange
                    ? 'Custom range active vendors'
                    : `${processedVendorStats.vendorsWithoutOrders} without orders`,
                icon: <Package size={18} />,
                bg: "linear-gradient(135deg, #fef3c7, #fde68a)",
                color: "#f59e0b"
            },
            {
                title: processedVendorStats.isCustomRange ? 'Custom Range Orders' : 'Total Vendor Orders',
                value: processedVendorStats.totalVendorOrders.toLocaleString("en-IN"),
                subtitle: processedVendorStats.isCustomRange
                    ? 'Total orders in selected range'
                    : `Avg ${processedVendorStats.averageOrdersPerVendor.toFixed(1)} per vendor`,
                icon: <TrendingUp size={18} />,
                bg: "linear-gradient(135deg, #dbeafe, #bfdbfe)",
                color: "#3b82f6"
            },
            {
                title: processedVendorStats.isCustomRange ? 'Range Revenue' : 'Top Vendors',
                value: topPerformingVendorsData.length || 0,
                subtitle: processedVendorStats.isCustomRange
                    ? 'Top vendors in selected range'
                    : `${processedVendorStats.averageRevenuePerVendor.toLocaleString("en-IN", {
                        style: "currency",
                        currency: "INR",
                        minimumFractionDigits: 0
                    })} avg revenue`,
                icon: <DollarSign size={18} />,
                bg: "linear-gradient(135deg, #ede9fe, #ddd6fe)",
                color: "#8b5cf6"
            }
        ];

        return (
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: isMobile ? "repeat(2,1fr)" : "repeat(4,1fr)",
                    gap: "12px",
                    marginBottom: "20px",
                    marginTop: "-28px"
                }}
            >
                {cards.map((c, i) => (
                    <div
                        key={i}
                        style={{
                            background: c.bg,
                            padding: isMobile ? "12px" : "16px",
                            borderRadius: "12px",
                            border: "1px solid #fff",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                            position: "relative",
                            overflow: "hidden"
                        }}
                    >
                        <div style={{ zIndex: 1 }}>
                            <p style={{
                                fontSize: 11,
                                fontWeight: 600,
                                color: "#64748b",
                                marginBottom: "4px"
                            }}>
                                {c.title}
                            </p>
                            <p style={{
                                fontSize: isMobile ? 16 : 20,
                                fontWeight: 800,
                                marginBottom: "4px",
                                color: c.color
                            }}>
                                {c.value}
                            </p>
                            {c.subtitle && (
                                <p style={{ fontSize: 10, color: "#64748b", margin: 0 }}>
                                    {c.subtitle}
                                </p>
                            )}
                        </div>

                        <div style={{
                            position: "absolute",
                            right: "12px",
                            top: "12px",
                            width: 36,
                            height: 36,
                            borderRadius: "8px",
                            background: `${c.color}20`,
                            color: c.color,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 1
                        }}>
                            {c.icon}
                        </div>

                        {c.trend === "custom" && (
                            <div style={{
                                position: 'absolute',
                                top: '8px',
                                right: '8px',
                                background: '#7c3aed20',
                                color: '#7c3aed',
                                padding: '2px 8px',
                                borderRadius: '12px',
                                fontSize: '9px',
                                fontWeight: '600',
                                zIndex: 1
                            }}>
                                <Calendar size={8} style={{ marginRight: '4px', display: 'inline-block' }} />
                                Custom
                            </div>
                        )}
                    </div>
                ))}
            </div>
        );
    };

    /* ---------------- TOP PERFORMING VENDORS DETAILS ---------------- */

    const TopVendorsDetails = () => {
        if (loadingCustomRange) {
            return (
                <div style={{
                    padding: 40,
                    textAlign: 'center',
                    color: '#64748b',
                    background: '#f8fafc',
                    borderRadius: '12px',
                    marginBottom: '20px'
                }}>
                    <RefreshCw size={20} className="spin" style={{ marginBottom: '12px', display: 'block', margin: '0 auto' }} />
                    Loading custom range vendor data...
                </div>
            );
        }

        if (!topPerformingVendorsData.length) {
            const currentStats = isCustomRangeActive && customRangeStats ? customRangeStats : stats;

            return (
                <div
                    style={{
                        background: "white",
                        borderRadius: "16px",
                        padding: isMobile ? "16px" : "20px",
                        border: "1px solid #e2e8f0",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                        marginBottom: "20px"
                    }}
                >
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 12
                    }}>
                        <h4 style={{ fontWeight: 800, color: "#1e293b", margin: 0 }}>
                            Top Performing Vendors
                        </h4>
                        {processedVendorStats.isCustomRange && (
                            <div style={{
                                background: '#f8fafc',
                                padding: '4px 8px',
                                borderRadius: '6px',
                                fontSize: '10px',
                                color: '#64748b',
                                border: '1px solid #e2e8f0',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px'
                            }}>
                                <Calendar size={10} />
                                Custom Range
                            </div>
                        )}
                    </div>
                    <p style={{ color: "#64748b", fontSize: 14 }}>
                        No top performing vendors data available
                    </p>
                </div>
            );
        }

        return (
            <div
                style={{
                    background: "white",
                    borderRadius: "16px",
                    padding: isMobile ? "16px" : "20px",
                    border: "1px solid #e2e8f0",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                    marginBottom: "20px"
                }}
            >
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 16
                }}>
                    <h4 style={{ fontWeight: 800, color: "#1e293b", margin: 0 }}>
                        Top Performing Vendors
                        {processedVendorStats.isCustomRange && (
                            <span style={{
                                fontSize: 12,
                                fontWeight: 400,
                                color: "#64748b",
                                marginLeft: "8px"
                            }}>
                                ({formatDate(startDate)} - {formatDate(endDate)})
                            </span>
                        )}
                    </h4>
                    {processedVendorStats.isCustomRange && (
                        <div style={{
                            background: '#f8fafc',
                            padding: '4px 8px',
                            borderRadius: '6px',
                            fontSize: '10px',
                            color: '#64748b',
                            border: '1px solid #e2e8f0',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px'
                        }}>
                            <Calendar size={10} />
                            Custom Range
                        </div>
                    )}
                </div>

                <div style={{
                    display: "grid",
                    gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
                    gap: "12px"
                }}>
                    {topPerformingVendorsData.map((vendor, index) => {
                        const currentStats = isCustomRangeActive && customRangeStats ? customRangeStats : stats;
                        const fullVendorData = currentStats?.allVendors?.find(v => v.vendorId === vendor.vendorId);

                        return (
                            <div
                                key={vendor.vendorId}
                                style={{
                                    background: index === 0 ?
                                        "linear-gradient(135deg, #fef3c7, #fde68a)" :
                                        index === 1 ?
                                            "linear-gradient(135deg, #e0e7ff, #c7d2fe)" :
                                            "linear-gradient(135deg, #fce7f3, #fbcfe8)",
                                    padding: "16px",
                                    borderRadius: "12px",
                                    border: "1px solid rgba(255,255,255,0.3)",
                                    position: "relative"
                                }}
                            >
                                <div style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "8px"
                                }}>
                                    <p style={{ fontSize: 14, fontWeight: 800, margin: 0, color: "#1e293b" }}>
                                        Vendor {vendor.vendorId}
                                    </p>
                                    <span style={{
                                        fontSize: 10,
                                        marginTop: "12px",
                                        fontWeight: 600,
                                        padding: "2px 8px",
                                        background: fullVendorData?.status === "ACTIVE" ? "#10b981" : "#f59e0b",
                                        color: "white",
                                        borderRadius: "12px"
                                    }}>
                                        {fullVendorData?.status || "UNKNOWN"}
                                    </span>
                                </div>

                                {processedVendorStats.isCustomRange && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '8px',
                                        right: '8px',
                                        background: '#7c3aed20',
                                        color: '#7c3aed',
                                        padding: '2px 8px',
                                        borderRadius: '12px',
                                        fontSize: '9px',
                                        fontWeight: '600'
                                    }}>
                                        #Rank {index + 1}
                                    </div>
                                )}

                                <div style={{ marginBottom: "8px" }}>
                                    <p style={{ fontSize: 12, fontWeight: 600, color: "#64748b", marginBottom: "4px" }}>
                                        {processedVendorStats.isCustomRange ? 'Range Revenue' : 'Total Revenue'}
                                    </p>
                                    <p style={{ fontSize: 18, fontWeight: 800, margin: 0 }}>
                                        ₹{vendor.revenue?.toLocaleString("en-IN", { minimumFractionDigits: 2 }) || "0"}
                                    </p>
                                </div>

                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr",
                                    gap: "8px"
                                }}>
                                    <div>
                                        <p style={{ fontSize: 10, color: "#64748b", marginBottom: "2px" }}>
                                            {processedVendorStats.isCustomRange ? 'Range Orders' : 'Orders'}
                                        </p>
                                        <p style={{ fontSize: 12, fontWeight: 700, margin: 0 }}>
                                            {fullVendorData?.totalOrders || 0}
                                        </p>
                                    </div>
                                    <div>
                                        <p style={{ fontSize: 10, color: "#64748b", marginBottom: "2px" }}>Share</p>
                                        <p style={{ fontSize: 12, fontWeight: 700, margin: 0 }}>
                                            {vendor.percentage || "0%"}
                                        </p>
                                    </div>
                                </div>

                                <div style={{ marginTop: "8px" }}>
                                    <p style={{ fontSize: 10, color: "#64748b", marginBottom: "2px" }}>
                                        Sales Growth
                                    </p>
                                    <p style={{
                                        fontSize: 11,
                                        fontWeight: 600,
                                        color: vendor.salesGrowth?.includes("-") ? "#ef4444" : "#10b981",
                                        margin: 0
                                    }}>
                                        {vendor.salesGrowth || "0%"}
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    /* ---------------- ALL VENDORS TABLE ---------------- */

    const AllVendorsTable = () => {
        const currentStats = isCustomRangeActive && customRangeStats ? customRangeStats : stats;

        if (!currentStats?.allVendors?.length) return null;

        const vendorsToShow = currentStats.allVendors.slice(0, isMobile ? 5 : 10);

        return (
            <div
                style={{
                    background: "white",
                    borderRadius: "16px",
                    padding: isMobile ? "16px" : "20px",
                    border: "1px solid #e2e8f0",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                    marginBottom: "20px"
                }}
            >
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 16
                }}>
                    <h4 style={{ fontWeight: 800, color: "#1e293b", margin: 0 }}>
                        All Vendors ({currentStats.allVendors.length})
                        {processedVendorStats.isCustomRange && (
                            <span style={{
                                fontSize: 12,
                                fontWeight: 400,
                                color: "#64748b",
                                marginLeft: "8px"
                            }}>
                                ({formatDate(startDate)} - {formatDate(endDate)})
                            </span>
                        )}
                    </h4>
                    {processedVendorStats.isCustomRange && (
                        <div style={{
                            background: '#f8fafc',
                            padding: '4px 8px',
                            borderRadius: '6px',
                            fontSize: '10px',
                            color: '#64748b',
                            border: '1px solid #e2e8f0',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px'
                        }}>
                            <Calendar size={10} />
                            Custom Range
                        </div>
                    )}
                </div>

                <div style={{ overflowX: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr style={{ borderBottom: "2px solid #e2e8f0" }}>
                                <th style={{ textAlign: "left", padding: "12px 8px", fontSize: 12, fontWeight: 600, color: "#64748b" }}>Vendor ID</th>
                                <th style={{ textAlign: "left", padding: "12px 8px", fontSize: 12, fontWeight: 600, color: "#64748b" }}>Status</th>
                                <th style={{ textAlign: "left", padding: "12px 8px", fontSize: 12, fontWeight: 600, color: "#64748b" }}>
                                    {processedVendorStats.isCustomRange ? 'Range Orders' : 'Orders'}
                                </th>
                                <th style={{ textAlign: "left", padding: "12px 8px", fontSize: 12, fontWeight: 600, color: "#64748b" }}>
                                    {processedVendorStats.isCustomRange ? 'Range Revenue' : 'Revenue'}
                                </th>
                                <th style={{ textAlign: "left", padding: "12px 8px", fontSize: 12, fontWeight: 600, color: "#64748b" }}>Growth</th>
                            </tr>
                        </thead>
                        <tbody>
                            {vendorsToShow.map((vendor) => (
                                <tr key={vendor.vendorId} style={{ borderBottom: "1px solid #f1f5f9" }}>
                                    <td style={{ padding: "12px 8px", fontSize: 12, fontWeight: 600 }}>#{vendor.vendorId}</td>
                                    <td style={{ padding: "12px 8px" }}>
                                        <span style={{
                                            fontSize: 10,
                                            fontWeight: 600,
                                            padding: "4px 8px",
                                            background: vendor.status === "ACTIVE" ? "#dcfce7" :
                                                vendor.status === "NO_ORDERS" ? "#fef3c7" : "#fee2e2",
                                            color: vendor.status === "ACTIVE" ? "#059669" :
                                                vendor.status === "NO_ORDERS" ? "#d97706" : "#dc2626",
                                            borderRadius: "12px"
                                        }}>
                                            {vendor.status || "UNKNOWN"}
                                        </span>
                                    </td>
                                    <td style={{ padding: "12px 8px", fontSize: 12, fontWeight: 600 }}>
                                        {vendor.totalOrders}
                                    </td>
                                    <td style={{ padding: "12px 8px", fontSize: 12, fontWeight: 600 }}>
                                        ₹{vendor.totalRevenue?.toLocaleString("en-IN", { minimumFractionDigits: 2 }) || "0.00"}
                                    </td>
                                    <td style={{ padding: "12px 8px" }}>
                                        <span style={{
                                            fontSize: 11,
                                            fontWeight: 600,
                                            color: vendor.salesGrowth?.includes("-") ? "#ef4444" : "#10b981"
                                        }}>
                                            {vendor.salesGrowth || "0%"}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {currentStats.allVendors.length > vendorsToShow.length && (
                    <div style={{ marginTop: 12, textAlign: "center" }}>
                        <p style={{ fontSize: 12, color: "#64748b" }}>
                            Showing {vendorsToShow.length} of {currentStats.allVendors.length} vendors
                        </p>
                    </div>
                )}
            </div>
        );
    };

    /* ---------------- VENDOR PERFORMANCE CHART ---------------- */

    const VendorPerformanceChart = () => {
        const chartTitle = processedVendorStats.isCustomRange
            ? `Top Vendors by Revenue: ${formatDate(startDate)} - ${formatDate(endDate)}`
            : "Top Vendors by Revenue";

        return (
            <div
                style={{
                    background: "white",
                    borderRadius: "24px",
                    padding: isMobile ? "20px" : "28px",
                    border: "1px solid #e2e8f0",
                    boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05)"
                }}
            >
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 16
                }}>
                    <h4 style={{ fontWeight: 800, color: "#1e293b", margin: 0 }}>
                        {chartTitle}
                    </h4>
                    {processedVendorStats.isCustomRange && (
                        <div style={{
                            background: '#f8fafc',
                            padding: '6px 12px',
                            borderRadius: '8px',
                            fontSize: '12px',
                            color: '#64748b',
                            border: '1px solid #e2e8f0',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                        }}>
                            <Calendar size={12} />
                            Custom Range
                        </div>
                    )}
                </div>

                {vendorPerformanceData.length > 0 ? (
                    <div style={{ height: isMobile ? 280 : 400 }}>
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart data={vendorPerformanceData}>
                                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                                <XAxis
                                    dataKey="name"
                                    stroke="#64748b"
                                    fontSize={12}
                                    angle={isMobile ? -45 : 0}
                                    textAnchor={isMobile ? "end" : "middle"}
                                    height={isMobile ? 60 : 40}
                                />
                                <YAxis
                                    tickFormatter={(v) => `₹${(v / 1000).toFixed(0)}K`}
                                    stroke="#64748b"
                                    fontSize={12}
                                />
                                <Tooltip
                                    formatter={(value, name) => {
                                        if (name === "revenue") {
                                            return [`₹${value.toLocaleString("en-IN")}`, processedVendorStats.isCustomRange ? "Range Revenue" : "Revenue"];
                                        }
                                        return [value, processedVendorStats.isCustomRange ? "Range Orders" : "Orders"];
                                    }}
                                    labelFormatter={(label) => label}
                                    contentStyle={{
                                        borderRadius: "8px",
                                        border: "1px solid #e2e8f0"
                                    }}
                                />

                                <Bar
                                    dataKey="revenue"
                                    fill={processedVendorStats.isCustomRange ? "#8b5cf6" : "#10b981"}
                                    radius={[8, 8, 0, 0]}
                                />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                ) : (
                    <div style={{
                        height: isMobile ? 200 : 300,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#f8fafc",
                        borderRadius: "12px"
                    }}>
                        <p style={{ color: "#64748b", fontSize: 14 }}>
                            No revenue data available for vendors
                        </p>
                    </div>
                )}
            </div>
        );
    };

    /* ---------------- ERROR DISPLAY ---------------- */

    if (error && !stats) {
        return (
            <div style={{
                padding: "20px",
                textAlign: "center",
                color: "#ef4444",
                background: "#fef2f2",
                borderRadius: "12px",
                margin: "10px",
                border: "1px solid #fecaca"
            }}>
                <h4 style={{ fontWeight: 600 }}>⚠️ API Connection Error</h4>
                <p>{error}</p>
                <p style={{ fontSize: "12px", color: "#64748b", marginTop: "10px" }}>
                    Please check your internet connection and authentication.
                </p>
            </div>
        );
    }

    /* ---------------- RENDER ---------------- */

    return (
        <>
            <VendorSummaryCards />
            <TopVendorsDetails />
            <AllVendorsTable />
            <VendorPerformanceChart />
        </>
    );
};

export default Financials;